import { type DomainAccessControlConfig } from '../utils/domain/accessControl'
import { Permission } from './permissions'
import { FeatureEntitlements } from './featureEntitlements'
/**
 * Access control configuration for viewing delivery software routes.
 *
 * Requires:
 * - Permission: partner_bulk_delivery_route.view
 * - Entitlement: fulfillment.delivery_software.partner_bulk_delivery_enabled
 *
 * This ensures only retailers with delivery software enabled and users with
 * the appropriate role can access route management features.
 */
export const deliverySoftwareAccessControl: DomainAccessControlConfig = [
  {
    permissions: [Permission.PartnerBulkDeliveryRouteView, Permission.WarehouseLocationHoursView],
    featureEntitlementIds: [FeatureEntitlements.PartnerBulkDeliveryEnabled],
    restrictedBannersAllowed: true,
  },
]

/**
 * Access control configuration for editing delivery software routes.
 *
 * Requires:
 * - Permission: partner_bulk_delivery_route.modify
 *
 * This gates route editing capabilities (reorder, add/remove orders, cancel routes).
 */
export const deliverySoftwareEditAccessControl: DomainAccessControlConfig = [
  {
    permissions: [Permission.PartnerBulkDeliveryRouteModify],
    restrictedBannersAllowed: true,
  },
]
